import GenericListPanel from "./GenericListPanel";

export default function TestimonialsPanel() {
  return (
    <GenericListPanel
      endpoint="testimonials"
      testidPrefix="testimonials"
      eyebrow="04"
      title="Testimonials"
      description="Customer reviews displayed in the testimonials grid."
      emptyItem={{ name: "", tag: "General", quote: "", order: 0 }}
      itemLabel={(it) => it.name}
      fields={[
        { name: "name", label: "Reviewer Name", type: "text" },
        { name: "tag", label: "Project Tag (e.g. Metal Building, Custom Fence)", type: "text" },
        { name: "quote", label: "Review Text", type: "textarea" },
      ]}
    />
  );
}
